import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { BgColorOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ShellComponent } from 'projects/app-default/src/app/ui/display/local-shell.component';
export interface IPageComponentSocialMediaCarouselComponentData extends NICmsContentComponent.IData {
    title?: string;
    copy?: string;
    subtitle?: string;
    cta_copy?: string;
    cta_link?: string;
    background_color?: string;
    elements: Element[];
}
interface Element {
    image?: string;
    image_url?: string;
    image_link?: string;
    username?: string;
}

let uid = 0;
@Component({
    selector: 'page-component-social-media-carousel',
    templateUrl: 'social-media-carousel.html',
    styleUrls: ['./social-media-carousel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule, ImageModule, ShellComponent, HrefComponent, CarouselModule]
})
@ICmsComponent<PageComponentSocialMediaCarouselComponent>({
    id: 'social-media-carousel',
    name: 'Social Media Carousel Layout',
    tags: ['Category', 'Social Media'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'background_color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            title: 'Background Color',
            options: BgColorOptions,
            description: 'Background color'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'copy',
            title: 'Copy'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'cta_copy',
            title: 'CTA copy'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'cta_link',
            title: 'CTA link'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'elements',
            title: 'Images',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Item',
            defaultSize: 4,
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'image_link',
                    title: 'Image link'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'username',
                    title: 'Username @'
                }
            ]
        }
    ]
})
export class PageComponentSocialMediaCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: IPageComponentSocialMediaCarouselComponentData;

    readonly uid = `social-media-carousel-${uid++}`;
}
